import {Check} from '@jobseeker/lotus/icons';
import {Box, Typography, styled} from '@mui/material';
import {getOldLink} from '@jobseeker/lotus/utils';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {UserProfileCardProps} from '../type';
import {Image} from '@jobseeker/lotus/components/Image';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const LinkSection = styled(Box)(props => ({
  padding: 0,
  '.sectionLink': {
    display: 'flex',
    columnGap: '5px',
    justifyContent: 'space-between',
    padding: props.theme.spacing(0.5, 1.5),
    '&.incompleteSection': {
      backgroundColor: '#91B87929',
      padding: props.theme.spacing(1, 1.5),
    },
    margin: props.theme.spacing(1, 0),
    borderRadius: props.theme.spacing(2),
    color: props.theme.palette.secondary.dark,
    cursor: 'pointer',
    ':hover': {
      '.label': {
        textDecoration: 'underline',
      },
    },
  },
  '.sectionLink:last-of-type': {
    marginBottom: 0,
  },
  '.sectionLink:first-of-type': {
    marginTop: 0,
  },
}));

export default (props: UserProfileCardProps) => {
  const isLarge = useIsLargeDevice();
  const fontSize = isLarge ? 15 : 12;
  // const fontSize = 14, md:12;
  return (
    <LinkSection>
      {props.dropDownLinks?.map((link, i) => (
        <Box
          className={`sectionLink ${
            !link.isCompleted ? 'incompleteSection' : ''
          }`}
          key={`userprofilelink${i}`}
          onClick={event => {
            event?.preventDefault();
            openUrl(`${getOldLink(link.url)}`, '_blank');
          }}
        >
          <Typography
            fontSize={{xxs: 14, md: 12}}
            variant="body3"
            className="label"
          >
            {link.label}
          </Typography>
          <Typography
            color={'primary'}
            variant="body3"
            fontWeight={500}
            fontSize={{xxs: 14, md: 12}}
            // sx={{textDecoration: 'none !important'}}
          >
            {link.isCompleted ? (
              <Image
                src={Check}
                alt={'Completed'}
                width={fontSize}
                height={fontSize}
                objectFit="cover"
              />
            ) : (
              'Add'
            )}
          </Typography>
        </Box>
      ))}
    </LinkSection>
  );
};
